export default "__VITE_ASSET__c194beae__"